import React from 'react'
import Svg, { Path } from 'react-native-svg'
import { StyleProp, ViewStyle } from 'react-native'

interface CurvyArrowProps {
  style: StyleProp<ViewStyle>
}

export const CurvyArrow = ({ style }: CurvyArrowProps) => {
  return (
    <Svg width="30" height="47" viewBox="0 0 30 47" fill="none" style={style}>
      <Path
        // eslint-disable-next-line max-len
        d="M2.2523 0.302648C1.47475 0.326946 0.864109 0.976978 0.888408 1.75453C0.912706 2.53209 1.56274 3.14273 2.34029 3.11843L2.2963 1.71054L2.2523 0.302648ZM9.35788 42.3306C9.23157 43.0982 9.75144 43.8229 10.5191 43.9492L23.028 46.0076C23.7956 46.1339 24.5203 45.6141 24.6466 44.8464C24.7729 44.0788 24.2531 43.3542 23.4854 43.2278L12.3664 41.3981L14.1961 30.279C14.3224 29.5114 13.8025 28.7868 13.0349 28.6604C12.2673 28.5341 11.5426 29.054 11.4163 29.8216L9.35788 42.3306ZM2.2963 1.71054L2.34029 3.11843C7.78805 2.94819 12.9406 3.92991 17.1002 5.81112C21.2682 7.69616 24.3471 10.4376 25.8391 13.7358C27.3105 16.9884 27.3323 20.9866 25.0043 25.6427C22.6567 30.3378 17.922 35.679 9.9267 41.4148L10.7478 42.5593L11.5688 43.7038C19.7721 37.8188 24.8975 32.1555 27.524 26.9025C30.17 21.6105 30.2798 16.7171 28.4058 12.5747C26.5525 8.47782 22.8526 5.32086 18.2611 3.24427C13.661 1.16385 8.07316 0.120746 2.2523 0.302648L2.2963 1.71054Z"
        fill="white"
      />
    </Svg>
  )
}
